
























































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";
import { Claim, ClaimType } from "@/shared/types";
import Pill from "@/shared/components/ui/Pill.vue";
import Button from "@/shared/components/ui/Button.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import { claimTypeIcon } from "@/shared/awesomeIconMapper";
import { toLower } from "lodash";

@Component({
  components: {
    Pill,
    Button,
    CurrencyAmount,
  },
})
export default class ClaimDetail extends Vue {
  claimTypeIcon = claimTypeIcon;
  @Prop() claim: Claim;

  ClaimType = ClaimType;

  claimNumberWithLine (lineNumber: number): string {
    if (lineNumber === null || lineNumber === undefined || lineNumber <= 0) {
      return this.claim.claimNumber;
    }
    return this.claim.claimNumber + "-" + lineNumber;
  }

  get formattedServiceDate (): string {
    return moment(this.claim.serviceDate).format("MMM D, YYYY");
  }
}
